import { Button, Flex, FlexProps } from "@chakra-ui/react"
import { useInstantSearch } from "react-instantsearch-core"

interface IShowMoreProps extends FlexProps {
  showPrevious: () => void
}

const ShowPrevious = ({ showPrevious }: IShowMoreProps) => {
  const { status } = useInstantSearch()
  return (
    <Flex justifyContent={"center"}>
      <Button
        onClick={showPrevious}
        size={"sm"}
        bgColor={"yellow.400"}
        _hover={{
          bgColor: "yellow.500",
        }}
        _active={{
          bgColor: "yellow.500",
        }}
        color={"black"}
        px={10}
        py={5}
        isLoading={status === "loading" || status === "stalled"}
        loadingText={"Loading ..."}
      >
        {"Show Previous"}
      </Button>
    </Flex>
  )
}

export default ShowPrevious
